import { useEffect } from 'react';

import { ConversationEventGroups } from 'components/conversation/conversationEventGroups';
import { useReadPatchedConversation } from 'utils/conversation/useReadPatchedConversation';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import styles from './conversationMessages.module.scss';

/** Represents the messages section of the conversation main view. */
export const ConversationMessages = (): JSX.Element => {
  const { csid } = useAppPathParams('/conversation/:csid');

  const [readConversations, { data, asyncStatus }] =
    useReadPatchedConversation();

  // Handles reading the conversation.
  useEffect(() => {
    readConversations({ csid: parseInt(csid) });
  }, [csid, readConversations]);

  return (
    <>
      {asyncStatus === 'fulfilled' && data && (
        <ConversationEventGroups
          className={styles.root}
          mainConversation={data.data.history.main_conversation}
          groupsConfig={[
            'group:adachat',
            'group:digitalgeniuschat',
            'group:kindlychat',
            'group:contact_form',
            'group:email',
            'group:facebook_messenger',
            'group:instagram_story',
            'group:messenger',
            'group:pstn_phone',
            'group:sms',
            'group:twitter',
            'group:voicemail',
            'group:whats_app',
            'group:widget_chat',
            'group:conversation:wrapup_message',
          ]}
        />
      )}
    </>
  );
};
